import React, { useEffect } from "react";

const useRemoveSEOTagsCustomDomain = () => {
  useEffect(() => {
    // Remove __TITLE__ placeholder if it exists
    const titleElement = document.querySelector("title");
    if (titleElement && titleElement.textContent === "__TITLE__") {
      titleElement.textContent = window.location.hostname.replace("www.", "");
    }
  }, []);
};

export default useRemoveSEOTagsCustomDomain;
